import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_garden_outdoor: FaireCategoryEntity = {
  token: "catalog_cat_garden-outdoor",
  type: "category",
  name: "Garden & outdoor",
  count: 342,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
